import styled from 'styled-components';

import { paragraphs } from '@proprioo/salatim';

export const Price = styled.span`
  ${paragraphs.bodyLight2};
`;
